<template>
  <basic-modal ref="basicModal" :modal-id="'restore-draft-modal'" :size="'md'">
    <template #title>
      {{ $t('winelist.addWineModal.restoreDraftTitle') }}
    </template>
    <div class="body">
      <h3>{{ $t('winelist.addWineModal.restoreDraftQuestion') }}</h3>
    </div>
    <template #footer>
      <b-button class="w-m" @click="handleCancel">neu starten</b-button>
      <b-button class="w-m" @click="handleConfirm" variant="success">Wieder herstellen</b-button>
    </template>
  </basic-modal>
</template>
<script>
import BasicModal from '@/components/modals/BasicModal.vue'

export default {
  name: 'RestoreDraftModal',
  components: {
    BasicModal
  },
  methods: {
    showModal() {
      this.$refs.basicModal.showModal()
    },
    handleConfirm() {
      this.$emit('confirmRestore')
      this.$refs.basicModal.hideModal()
    },
    handleCancel() {
      this.$emit('cancelRestore')
      this.$refs.basicModal.hideModal()
    }
  }
}
</script>
<style scoped></style>